
import Vue from 'vue';
import EventService from '../services/EventService';
import DemoVideoService from '../services/DemoVideoService';
import {mapState} from 'vuex';

type Data = {
  title: string;
  description: string;
  path: string;
};

export default Vue.extend({
  name: 'DemoVideo',
  computed: {
    ...mapState(['user']),
  },
  data: (): Data => ({
    title: '',
    description: '',
    path: '',
  }),
  async mounted() {
    if (this.user) {
      const token = await this.user.getIdToken();
      const video = document.getElementById('video');

      if (video) {
        try {
          const {data} = await EventService.getDemoVideo(token);
          this.title = data.title;
          this.description = data.description;
          this.path = data.path;
          console.log(data);
          DemoVideoService.setVideo(
            token,
            this.path,
            video as HTMLMediaElement
          );
        } catch (err) {
          console.log(err);
        }
      }
    }
  },
});
